import * as TabsPrimitive from "@radix-ui/react-tabs"

import { TabsContent } from "@/components/ui/tabs-content"
import { TabsList } from "@/components/ui/tabs-list"
import { TabsTrigger } from "@/components/ui/tabs-trigger"

const Tabs = TabsPrimitive.Root

export { Tabs, TabsList, TabsTrigger, TabsContent }
